import * as form from '../form';

export const financialNonPaymentNonFederal = (data = {}) => {
  const items = ((data.List || {}).items || []).map((x) => {
    const xitem = x.Item || {};
    return {
      Item: {
        TaxType: form.radio(xitem.TaxType),
        TaxTypeExplain: form.textarea(xitem.TaxTypeExplain),
        Year: form.datecontrol(xitem.Year),
        AmountOwed: form.number(xitem.AmountOwed),
        AmountOwedIdk: form.notapplicable(xitem.AmountOwedIdk),
        FilingDate: form.datecontrol(xitem.FilingDate),
        ActionsTaken: form.checkboxgroup(xitem.ActionsTaken),
        ActionsTakenReason: form.textarea(xitem.ActionsTakenReason),
        HasPaidInFull: form.branch(xitem.HasPaidInFull),
        WhenPaidInFull: form.datecontrol(xitem.WhenPaidInFull),
        WhenFiled: form.datecontrol(xitem.WhenFiled),
        HasFiledOnTime: form.branch(xitem.HasFiledOnTime),
      },
    };
  });
  return {
    HasNonpaymentNonfederal: form.branch(data.HasNonpaymentNonfederal),
    List: form.collection(items, (data.List || {}).branch),
  };
};
